import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7v10l7 4v-18l-7 4","key":"svg-0"}],["path",{"d":"M21 7v10l-7 4v-18l7 4","key":"svg-1"}]]

/**
 * IconBrandMetabrainz
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbWV0YWJyYWlueiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyA3djEwbDcgNHYtMThsLTcgNCIgLz4KICA8cGF0aCBkPSJNMjEgN3YxMGwtNyA0di0xOGw3IDQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-metabrainz
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandMetabrainz = createReactComponent('outline', 'brand-metabrainz', 'BrandMetabrainz', __iconNode);

export default IconBrandMetabrainz;